"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Registry = void 0;
const Domain_1 = require("./Domain");
class Registry {
    constructor() {
        this.domains = new Set();
    }
    createDomainWithDescriptorsMap(descriptors) {
        const domain = new Domain_1.Domain();
        this.addDomain(domain);
        return [domain.addErrorsDescriptorsMap(descriptors), domain];
    }
    addDomain(domain) {
        for (const errorDescriptor of domain) {
            for (const domain of this.domains.values()) {
                domain.assertErrorCodeNotRegistered(errorDescriptor);
            }
        }
        this.domains.add(domain);
        domain.lock();
        return this;
    }
    assertErrorCodeNotRegistered(errorDescriptorOrCode) {
        for (const domain of this.domains.values()) {
            domain.assertErrorCodeNotRegistered(errorDescriptorOrCode);
        }
    }
    getErrorDescriptorForCode(code) {
        for (const domain of this.domains) {
            const descriptor = domain.getErrorDescriptorForCode(code);
            if (descriptor) {
                return descriptor;
            }
        }
    }
    *[Symbol.iterator]() {
        for (const domain of this.domains) {
            yield* domain;
        }
    }
}
exports.Registry = Registry;
